import { HttpClient } from '@angular/common/http';
import { CommonService, CustomTranslateHttpLoader, selectEnvironmentFile, TranslationService } from 'gast-common-ng';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient) {
    var urls = [
        './common-assets/i18n/',
        './portal-assets/i18n/',
        './onset-assets/i18n/',
        './assets/i18n/'
    ];
    return new CustomTranslateHttpLoader(httpClient, urls, '.json');
}
export function TranslationServiceFactory(translateService, commonService) {
    return new TranslationService(translateService, commonService);
}
var ɵ0 = { callback: selectEnvironmentFile, value: environment.envName };
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
